import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, tap, of as observableOf, throwError } from 'rxjs';

import { environment } from '@environments/environment';

const credentialsKey = 'currentUser';

@Injectable()
export class AuthenticationService {

    returnUrl: string;

    constructor(
        private http: HttpClient) { }

    login(data): Promise<any> {
        return new Promise((resolve, reject) => {
            this.sendToRestApiMethod(data).subscribe((res) => {
                if (res.token && res.user && res.user.email && res.user.email_verified) {
                    resolve(true);
                }
            }, (err) => {
                reject(err);
            }
        );
        });

    }

    logout(): Observable<boolean> {
        sessionStorage.removeItem(credentialsKey);
        localStorage.removeItem(credentialsKey);
        return observableOf(true);
    }

    sendToRestApiMethod(userData): Observable<any> {
        const href = `${environment.login}`;
        return this.http.post<any>(href, userData).pipe(
            tap(
                function (data) {
                    if (data.token && data.user && data.user.email && data.user.email_verified) {
                        const storage = localStorage;
                        storage.setItem(credentialsKey, JSON.stringify(data));
                    }
                
                    return data;
                }
            ),
            catchError(
                function (err) {
                    console.log(err);
                    return throwError(err);
                }
            )
        );
        
    }

    getUserInfo(): Observable<any> {
        const savedCredentials = this.getUser();
        return observableOf(savedCredentials);
    }

    isLogin() {
        if (localStorage.getItem(credentialsKey) || sessionStorage.getItem(credentialsKey)) {
            return true;
        }
        return false; 
    }

    getUserId() {
        let user = this.getUser();
        if (user) return user.id;
        return null;
    }

    getToken() {
        const savedCredentials = this.getStorageItem();
        return savedCredentials && savedCredentials['token'];
    }

    getUserRole(): Observable<any> {
        const savedCredentials = this.getUser();
        return observableOf(savedCredentials['role']);
    }

    checkUserAccessByURL (url) {
        if (url.includes('/client/dashboard')) return true;
        if (url.includes('/documentation')) return true;

        const menuList = this.getMenuList();

        for (let menu of menuList) {
            for (let submenu of menu.children) {
                if (url.includes(submenu.link)) return true;
            }
        }

        return false;
    }

    getUserMenuList () {
        const href = `${ environment.authorizeAccessMenu }`;
        let user = this.getUser();
        if (!user || !user.id) return observableOf(false);

        let params = new HttpParams().set('userId', user.id);

        return this.http.get<any>(href, { params }).pipe(
            tap(
                function (data) {

                    return data;
                }
            ),
            catchError(
                function (err) {
                    console.log(err);
                    return throwError (err);
                }
            )
        );

    }

    private getStorageItem() {
        const savedCredentialsStr = sessionStorage.getItem(credentialsKey) || localStorage.getItem(credentialsKey);
        const savedCredentials = JSON.parse(savedCredentialsStr);
        return savedCredentials;
    }

    getUser() {
        const savedCredentials = this.getStorageItem();
        if (savedCredentials && savedCredentials['user']) return savedCredentials['user'];
        return null;
    }

    getMenuList() {
        const savedCredentials = this.getStorageItem();
        if (savedCredentials && savedCredentials['menuList']) return savedCredentials['menuList'];
        return null;
    }

    setMenuList(menu) {
        const savedCredentials = this.getStorageItem();
        if (savedCredentials && savedCredentials['menuList']) {
            const storage = localStorage;
            savedCredentials['menuList'] = menu;
            storage.setItem(credentialsKey, JSON.stringify(savedCredentials));
        }
    }

    checkUserToken(){
        let savedCredentials = this.getStorageItem();
        return this.http.post<any>(environment.checkUserToken, {}).pipe(
            tap(function (data) {
                    if (data?.Token) {
                        savedCredentials['token'] = data.Token;
                        localStorage.setItem(credentialsKey, JSON.stringify(savedCredentials));
                    }
                    return data;
                }
            ),
            catchError(
                function (err) {
                    console.log(err);
                    return throwError(err);
                }
            )
        );
    }
}

